import React, { useMemo } from 'react';

import {
  RowProgress,
  SpanProgressTitle,
  SpanProgressValue
} from "./styles";
import { LinearProgress, Tooltip } from '@material-ui/core';

export default function AttachmentProgressBar({
    value,
    total,
    title,
    countType
}) {
  const progress = useMemo(() => {
    return (value / total) * 100
  }, [value, total])

  const showBottomCount = useMemo(() => {
    if (countType === 'NONE')
        return false;
    else if (countType === 'LABEL' && title)
        return false;
    return true;
  }, [countType])

  const showLabelCount = useMemo(() => {
    if (countType === 'NONE')
        return false;
    else if (countType === 'BOTTOM')
        return false;
    return countType === 'LABEL' && title;
  }, [countType])

  return(
    <RowProgress>
        { title && (
            <SpanProgressTitle>
                {title}
                { showLabelCount && (
                    <span> {value} / {total}</span>
                )}
            </SpanProgressTitle>
        )}
        { countType === 'NONE' ? (
            <Tooltip title={`${value} / ${total}`}>
                <LinearProgress variant="determinate" value={progress}/>
            </Tooltip>
            ) : (
                <LinearProgress variant="determinate" value={progress}/>
            )
        }
        { showBottomCount && (
            <SpanProgressValue>{value} / {total}</SpanProgressValue>
        )}
    </RowProgress>
  );
}
